<template>
<footer class="main-footer">
  <div class="container">
    <div class="columns">
      <div class="column">
        <a href="https://creativecommons.org" class="main-logo margin-bottom-bigger has-text-white" :aria-label="$t('footer.LOGO_ARIA_LABEL')">
          <svg xmlns="http://www.w3.org/2000/svg"
               preserveAspectRatio="xMidYMid meet"
               viewBox="0 0 304 73">
            <use href="static/logos/cc/logomark.svg#logomark"></use>
          </svg>
        </a>
        <address class="margin-bottom-normal">
          <span class="is-block">Creative Commons</span>
          <span>PO Box 1866, Mountain View CA 94042</span>
        </address>
        <a href="mailto:info@creativecommons.org" class="mail is-block">
          info@creativecommons.org
        </a>
        <a href="tel://+1-415-429-6753" class="phone">+1-415-429-6753</a>

        <div class="margin-vertical-large">
          <a href="https://www.instagram.com/creativecommons" class="social has-text-white" target="_blank" rel="noopener" aria-label="Instagram">
             <i class="icon instagram margin-right-small is-size-4" />
          </a>
          <a href="https://www.twitter.com/creativecommons" class="social has-text-white" target="_blank" rel="noopener" aria-label="Twitter">
             <i class="icon twitter margin-right-small is-size-4" />
          </a>
          <a href="https://www.facebook.com/creativecommons" class="social has-text-white" target="_blank" rel="noopener" aria-label="Facebook">
             <i class="icon facebook margin-right-small is-size-4" />
          </a>
          <a href="https://www.linkedin.com/company/creative-commons/" class="social has-text-white" target="_blank" rel="noopener" aria-label="LinkedIn">
             <i class="icon linkedin margin-right-small is-size-4" />
          </a>
        </div>
      </div>
      <div class="column is-half">
        <nav class="footer-navigation">
          <ul class="menu">
            <li>
              <a class="menu-item" href="https://creativecommons.org/about/contact/">{{ $t('footer.menu.CONTACT') }}</a>
            </li>
            <li>
              <a class="menu-item" href="https://creativecommons.org/privacy/">{{ $t('footer.menu.PRIVACY') }}</a>
            </li>
            <li>
              <a class="menu-item" href="https://creativecommons.org/policies/">{{ $t('footer.menu.POLICIES') }}</a>
            </li>
            <li>
              <a class="menu-item" href="https://creativecommons.org/terms/">{{ $t('footer.menu.TERMS') }}</a>
            </li>
          </ul>
        </nav>
        <div class="attribution margin-top-bigger">
          <p class="caption">
            {{ $t('footer.license.PART_1_BEFORE_LINK') }}
            <a href="https://creativecommons.org/policies#license" target="_blank" rel="noopener">{{ $t('footer.license.PART_1_LINK') }}</a>
            {{ $t('footer.license.PART_1_AFTER_LINK') }}
            {{ $t('footer.license.PART_2_BEFORE_LINK') }}
            <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener">
              {{ $t('footer.license.PART_2_LINK') }}
            </a>
            {{ $t('footer.license.PART_2_AFTER_LINK') }}
              <a href="https://fontawesome.com/" target="_blank" rel="noopener" class="has-text-white">
                {{ $t('footer.FONT_AWESOME_ATTRIBUTION') }}
             </a>
          </p>

          <div class="margin-top-smaller">
            <i class="icon cc-logo margin-right-small is-size-4 is-color-white" />
            <i class="icon cc-by margin-right-small is-size-4 is-color-white" />
          </div>
        </div>
      </div>
      <div class="column">
        <aside class="donate-section">
          <h5>{{ $t('footer.donate-section.TITLE') }}</h5>
          <p>{{ $t('footer.donate-section.SUB_TITLE') }}</p>
          <a class="button small donate" href="http://creativecommons.org/donate">
            <i class="icon cc-letterheart margin-right-small is-size-5 padding-top-smaller" />
            {{ $t('footer.donate-section.BUTTON_TEXT') }}
          </a>
        </aside>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'footer-section',
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "node_modules/bulma/sass/utilities/initial-variables";

.donate, .social {
  &:hover {
    text-decoration: none;
  }
}

.mail, .phone {
  @media screen and (max-width: $tablet - 1px) {
    padding: 24px 0;
    margin-bottom: 6px;
  }
}

.icon {
  vertical-align: middle;
}
</style>
